import { isLoggedIn } from '../../utils/auth'

export default (store) => {
  return ({
    path: 'social-media-engagements',
    onEnter: isLoggedIn(store),
    getComponent(nextState, cb) {
      const Offer = require('./containers').default
      cb(null, Offer)
    }
  })
}



// WEBPACK FOOTER //
// ./src/routes/SocialMediaRewardList/index.js